module.exports = __webpack_public_path__ + "img/img35.e8cd8a54.svg";